import type { Block } from '../types/report'
import { Heading } from './Heading'
import { Paragraph } from './Paragraph'
import { KpiGrid } from './KpiGrid'
import { TableBlock } from './TableBlock'
import { BarChartBlock } from './BarChartBlock'
import { LineChartBlock } from './LineChartBlock'
import { Heatmap } from './Heatmap'
import { Callout } from './Callout'

// Render a single block by its discriminated `type`. The default branch is typed
// `never`, so adding a block type without handling it fails the build.
export function BlockRenderer({ block }: { block: Block }) {
  switch (block.type) {
    case 'heading':
      return <Heading block={block} />
    case 'paragraph':
      return <Paragraph block={block} />
    case 'kpi_grid':
      return <KpiGrid block={block} />
    case 'table':
      return <TableBlock block={block} />
    case 'bar_chart':
      return <BarChartBlock block={block} />
    case 'line_chart':
      return <LineChartBlock block={block} />
    case 'heatmap':
      return <Heatmap block={block} />
    case 'callout':
      return <Callout block={block} />
    default: {
      const _exhaustive: never = block
      return _exhaustive
    }
  }
}
